import { useCallback, useState } from 'react';
import { getSubscriptionHistory } from '../../api';
import { resolveErrorMessage } from '../../utils/errorMessage';

const useSubscriptionHistory = ({ pageSize }) => {
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState('');
  const [historyItems, setHistoryItems] = useState([]);
  const [historyPage, setHistoryPage] = useState(1);
  const [historyTotal, setHistoryTotal] = useState(0);

  const loadSubscriptionHistory = useCallback(async (page = 1) => {
    setHistoryLoading(true);
    setHistoryError('');
    try {
      const resp = await getSubscriptionHistory({ page, page_size: pageSize });
      if (resp?.status !== 'success') {
        throw new Error(resolveErrorMessage(resp?.error_message, '获取历史订阅记录失败'));
      }
      setHistoryItems(resp.items || []);
      setHistoryTotal(Number(resp.total || 0));
      setHistoryPage(Number(resp.page || page));
    } catch (e) {
      setHistoryError(e?.message || String(e));
    } finally {
      setHistoryLoading(false);
    }
  }, [pageSize]);

  const openSubscriptionHistory = useCallback(() => {
    setHistoryOpen(true);
    loadSubscriptionHistory(1).catch(() => {});
  }, [loadSubscriptionHistory]);

  const closeSubscriptionHistory = useCallback(() => {
    setHistoryOpen(false);
  }, []);

  return {
    historyOpen,
    historyLoading,
    historyError,
    historyItems,
    historyPage,
    historyTotal,
    loadSubscriptionHistory,
    openSubscriptionHistory,
    closeSubscriptionHistory,
  };
};

export default useSubscriptionHistory;
